/* ts:disable */
type Noop = (...args: any[]) => void;
const noop: Noop = () => {};

export default noop;
